export default defineNuxtRouteMiddleware(async ({ params }) => {
  const { countryFrom, countryTo, currencyFrom, currencyTo, amount } = processIMTParams(params)

  if (!currencyFrom || !currencyTo) {
    return navigate(
      getIMTLiveUrl({
        countryFrom,
        countryTo,
        currencyFrom: countryFrom.defaultCurrency,
        currencyTo: countryTo.defaultCurrency,
        amount,
      }),
      { replace: true, redirectCode: 301 },
    )
  }

  if (!amount) {
    return navigate(
      getTransferUrl({
        countryFrom,
        countryTo,
        currencyFrom: countryFrom.defaultCurrency,
        currencyTo: countryTo.defaultCurrency,
      }),
      { replace: true, redirectCode: 301 },
    )
  }
})
